window.gsc_product_queries = {

  "andy-warhol-brillo-box-medium": [
    "andy warhol brillo box",
    "warhol brillo box art",
    "pop art collectibles warhol",
    "brillo box sculpture replica",
    "andy warhol collectible art"
  ],

  "default": [
    "movie collectibles",
    "entertainment collectibles",
    "pop culture collectibles",
    "collectible action figures",
    "star wars collectibles",
    "batman collectible figures",
    "superhero merchandise",
    "unique home decor items",
    "decorative accent furniture",
    "designer accent tables",
    "luxury home decor collectibles",
    "gift ideas collectibles",
    "vintage style decor items",
    "collector edition items",
    "display collectibles home decor"
  ]

};